import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { getDateDifferenceFromCurrentDate } from './date';
dayjs.extend(duration);
export const formatTimerDate = (countDown, date, formatDaysToString, hideHours, hideSeconds) => {
    const days = getDateDifferenceFromCurrentDate('days', date);
    const countdownDuration = dayjs.duration(countDown, 'seconds');
    const hours = countDown <= 0 ? '0' : countdownDuration.hours().toString();
    const minutes = countDown <= 0 ? '00' : countdownDuration.minutes().toString();
    const seconds = countDown <= 0 ? '00' : countdownDuration.seconds().toString();
    let formattedString = '';
    if (days > 0 && formatDaysToString) {
        formattedString = formatDaysToString?.(days.toString());
    }
    else if (hours && !hideHours) {
        formattedString = `${hours}h ${minutes}m ${seconds}s`;
    }
    else if (hideSeconds && hideHours) {
        formattedString = `${minutes}m`;
    }
    else {
        formattedString = `${minutes}m ${seconds}s`;
    }
    return {
        formattedString,
        hours,
        minutes,
        seconds,
    };
};
//# sourceMappingURL=timer.js.map